import { DashboardEditConfig } from "../types";

export enum DashboardEditActions {
	CHANGE_GENERAL_MOBILE_GRID_CONFIG = "CHANGE_GENERAL_MOBILE_GRID_CONFIG",
	CHANGE_EXTENDED_MOBILE_GRID_CONFIG = "CHANGE_EXTENDED_MOBILE_GRID_CONFIG",
	CHANGE_NON_MOBILE_GRID_CONFIG = "CHANGE_NON_MOBILE_GRID_CONFIG",
	CHANGE_ENTIRE_GRID_CONFIG = "CHANGE_ENTIRE_GRID_CONFIG",
}

export const dashboardEditReducer = (state: DashboardEditConfig, action: Record<string, any>) => {
	const { payload } = action;

	switch (action.type) {
		case DashboardEditActions.CHANGE_ENTIRE_GRID_CONFIG:
			return { ...state, ...payload };
		case DashboardEditActions.CHANGE_GENERAL_MOBILE_GRID_CONFIG:
			return {
				...state,
				mobileGridConfig: {
					...state.mobileGridConfig,
					mobileGridConfig: { ...state.mobileGridConfig, general: payload },
				},
			};
		case DashboardEditActions.CHANGE_EXTENDED_MOBILE_GRID_CONFIG:
			return {
				...state,
				mobileGridConfig: {
					...state.mobileGridConfig,
					mobileGridConfig: { ...state.mobileGridConfig, extended: payload },
				},
			};
		case DashboardEditActions.CHANGE_NON_MOBILE_GRID_CONFIG:
			return { ...state, nonMobileGridConfig: payload };

		default:
			return state;
	}
};
